import React from "react";
import { Translation } from "react-i18next";

export const proxyErrorText = function(error, text) {
  const defaultTxt = (
    <Translation>{t => <>{t("checkout.required")}</>}</Translation>
  );

  return (
    (error && (
      <span className="text-error">{(text && text) || defaultTxt}</span>
    )) ||
    null
  );
};
